import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export const Get2fa = () => {
  const { t } = useTranslation();
  const [key, setKey] = useState('');
  const [otp, setOtp] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setProgress(((new Date().getSeconds() % 30) / 30) * 100), 1000);
    return () => clearInterval(timer);
  }, []);

  const onGet2FA = async () => {
    if (!key.trim()) return;
    try {
      const { data } = await axios.get(`/api/tools/get2fa?key=${key}`);
      setOtp(data.data);
    } catch {
      toast.error(t('toolGet2fa.errorGet2fa'));
    }
  };

  useEffect(() => {
    if (key.length > 5) onGet2FA();
  }, [Math.floor(Date.now() / 30000)]);

  const onCopy = () => {
    if (otp) {
      navigator.clipboard.writeText(otp);
      toast.success(t('toolCommon.copySuccess'));
    }
  };

  return (
    <div style={{ maxWidth: 460, margin: '0 auto', padding: '36px 24px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 }}>🛡️ Get 2FA Code</h2>

      <div className="ms-card" style={{ padding: 24 }}>
        <label className="ms-label">Secret Key</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <input className="ms-input" value={key} onChange={e => setKey(e.target.value)} placeholder={t('toolGet2fa.placeholder')} />
          <button className="ms-btn ms-btn--primary" onClick={onGet2FA} style={{ padding: '0 20px', whiteSpace: 'nowrap' }}>
            {t('toolGet2fa.getCode')}
          </button>
        </div>

        <div
          onClick={onCopy}
          style={{
            padding: '28px 0',
            textAlign: 'center',
            borderRadius: 12,
            background: colors.surface,
            border: `1px solid ${colors.border}`,
            marginBottom: 14,
            cursor: otp ? 'pointer' : 'default',
          }}
        >
          <div
            style={{
              fontSize: 42,
              fontWeight: 800,
              color: otp ? colors.accent : colors.dim,
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: '.15em',
            }}
          >
            {otp || '------'}
          </div>
          <div style={{ fontSize: 11, color: colors.dim, marginTop: 4 }}>
            {otp ? t('toolGet2fa.clickToCopy') : t('toolGet2fa.enterKeyPrompt')}
          </div>
        </div>

        {/* Countdown bar */}
        <div style={{ height: 5, borderRadius: 3, overflow: 'hidden', background: 'linear-gradient(90deg, #10B981, #F59E0B, #EF4444)' }}>
          <div
            style={{
              height: '100%',
              background: colors.surface,
              marginLeft: 'auto',
              width: `${progress}%`,
              transition: 'width 1s linear',
              borderRadius: 3,
            }}
          />
        </div>
        <div style={{ fontSize: 11, color: colors.dim, textAlign: 'center', marginTop: 4 }}>
          {t('toolGet2fa.newCodeIn')} {30 - Math.floor(new Date().getSeconds() % 30)}
          {t('toolGet2fa.seconds')}
        </div>
      </div>
    </div>
  );
};
